export default __webpack_public_path__ + "static/media/premium_icon.cc643090.svg";